import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

const DatabaseBackup = () => {

    const [visible, setVisible] = useState(false);

    const THIRTY_MINUTES = 30*60*1000;

    const BACKUP_URL =
        'https://api.dhilluandsahi.com/database-backup/58b1a733asdf6bfdf7d1c40a8af9';

    useEffect(() => {

        let timer;

        const startTimer = () => {

            const lastBackupTime = localStorage.getItem(
                'databaseBackupPopupTime'
            );

            const now = Date.now();

            // First time
            if (!lastBackupTime) {

                setVisible(true);
                return;
            }

            const elapsed = now - Number(lastBackupTime);

            // 30 minutes already passed
            if (elapsed >= THIRTY_MINUTES) {

                setVisible(true);
                return;
            }

            // Remaining time
            const remaining = THIRTY_MINUTES - elapsed;

            timer = setTimeout(() => {
                setVisible(true);
            }, remaining);
        };

        startTimer();

        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        };

    }, []);


    const handleBackup = () => {

        // Reset timer
        localStorage.setItem(
            'databaseBackupPopupTime',
            Date.now().toString()
        );

        // Close popup
        setVisible(false);

        // Download backup
        window.location.href = BACKUP_URL;
    };


    return (
        <Modal
            show={visible}
            centered
            backdrop="static"
            keyboard={false}
        >

            <Modal.Header>
                <Modal.Title>
                    Database Backup
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="text-center py-4">

                <h5>
                    Please Backup Database
                </h5>

                <p className="text-muted">
                    Please download the latest database backup
                    to keep a safe copy.
                </p>

                <Button
                    variant=""
                    className="text-white fontweight700 fontsize14 redbg"
                    onClick={handleBackup}
                >
                    Backup Data
                </Button>

            </Modal.Body>

        </Modal>
    );
};

export default DatabaseBackup;